module.exports = __webpack_public_path__ + "static/media/icon-pencil.336c2eca.svg";